import { render } from "./WaveB.vue?vue&type=template&id=402ee28f&scoped=true"
import script from "./WaveB.vue?vue&type=script&lang=js"
export * from "./WaveB.vue?vue&type=script&lang=js"

import "./WaveB.vue?vue&type=style&index=0&id=402ee28f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\utente\\Documents\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402ee28f"]])

export default __exports__